webpackJsonp([174385864947821],{

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var newsArticles = _ref.newsArticles;
	    return _react2.default.createElement(
	        'div',
	        null,
	        newsArticles.map(function (article, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: "article-" + index },
	                _react2.default.createElement(
	                    'section',
	                    { id: article.node.frontmatter.path, className: 'hero is-sjs-dark-blue' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hero-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'title' },
	                                article.node.frontmatter.title
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'columns' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'column is-10 is-offset-1' },
	                                _react2.default.createElement(_Content.HTMLContent, { content: article.node.html })
	                            )
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PageQuery = exports.AerospaceNewsPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(11);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Team = __webpack_require__(16);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _ResourceList = __webpack_require__(18);
	
	var _ResourceList2 = _interopRequireDefault(_ResourceList);
	
	var _Contact = __webpack_require__(12);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _NewsArticlesSection = __webpack_require__(47);
	
	var _NewsArticlesSection2 = _interopRequireDefault(_NewsArticlesSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AerospaceNewsPageTemplate = exports.AerospaceNewsPageTemplate = function AerospaceNewsPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      newsArticles = _ref.newsArticles,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "San Juan Software | " + title
	    }),
	    _react2.default.createElement(_NewsArticlesSection2.default, { newsArticles: newsArticles }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section content is-sjs-dark-blue' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-v-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'span',
	              { className: 'header-font is-size-3' },
	              'More News:'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'button is-medium is-sjs-yellow', to: '/news' },
	              'News Home'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'button is-medium is-sjs-yellow', to: '/sjs-news' },
	              'SJS News'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'button is-medium is-sjs-yellow', to: '/iot-news' },
	              'IoT News'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Contact2.default, null)
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	  var newsArticles = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(AerospaceNewsPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: frontmatter.title,
	    content: html,
	    newsArticles: newsArticles
	  });
	};
	
	var PageQuery = exports.PageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-aerospace-news-page-js-2e59f5fb9860d734ad14.js